import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '../../../common/icons/CloseIcon';
import TextField from '../../../common/TextField';
import { CustomerEntry } from './VacancyForm';

interface VacancyCustomerCardProps {
  customers: CustomerEntry[];
  type: 'add' | 'edit' | 'view';
  onAddCustomer: () => void;
  onRemoveCustomer: (id: string) => void;
  setCustomers: (customers: CustomerEntry[]) => void;
}

const VacancyCustomerCard: React.FC<VacancyCustomerCardProps> = ({ type, customers, onAddCustomer, onRemoveCustomer, setCustomers }) => {
  const handleCustomerChange = (id: string, field: keyof CustomerEntry, value: string) => {
    setCustomers(customers.map(customer => {
      if (customer.id === id) {
        return {
          ...customer,
          [field]: value
        };
      }
      return customer;
    }));
  };

  return (
    <Box className="edit-section">
      {/* Title Row */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography className="edit-section-title">
          Customer(s)
        </Typography>
        {type !== 'view' && (
          <IconButton
            className="edit-section-add-button"
            onClick={onAddCustomer}
          >
            <AddIcon />
          </IconButton>
        )}
      </Box>

      {/* Customer Cards */}
      {customers.map((customer) => (
        <Box key={customer.id} className="edit-sub-section" sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', gap: 7 }}>
            <Box>
              <TextField
                label="Customer Name"
                sx={{ width: '360px' }}
                value={customer.customerName}
                onChange={(e) => handleCustomerChange(customer.id, 'customerName', e.target.value)}
                name={`customers[${customer.id}].customerName`}
              />
            </Box>
            <Box>
              <TextField
                label="Customer Country"
                sx={{ width: '360px' }}
                value={customer.customerCountry}
                onChange={(e) => handleCustomerChange(customer.id, 'customerCountry', e.target.value)}
                name={`customers[${customer.id}].customerCountry`}
              />
            </Box>
            <Box>
              <TextField
                label="No. Of Vacancies"
                sx={{ width: '360px' }}
                type="number"
                value={customer.numberOfVacancies}
                onChange={(e) => handleCustomerChange(customer.id, 'numberOfVacancies', e.target.value)}
                name={`customers[${customer.id}].numberOfVacancies`}
              />
            </Box>
            {type !== 'view' && customers.length > 1 && (
              <IconButton
                onClick={() => onRemoveCustomer(customer.id)}
                className="edit-section-close-button"
              >
                <CloseIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default VacancyCustomerCard; 